<template>
  <div>
    <span v-if="content.length < 200">{{ content }}</span>
    <span v-else>
      {{ expanded ? content : `${content.substring(0, 200)}...` }}
      <br/><br/>
      <el-link v-if="!expanded" type="primary" icon="el-icon-arrow-down" @click="expanded = true">View More</el-link>
    </span>
  </div>
</template>
<script>
export default {
  name: 'Description',
  props: { content: { type: String, required: true } },
  data() {
    return {
      expanded: false,
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Description.vue